// @flow
const $ = require('jquery');

require('bootstrap/js/transition');
require('bootstrap/js/collapse');

const PLUGIN_NAME = 'zusnaCalendar';

const DEFAULTS = {
	debug:                true,
	container:            null,
	sourceList:           '.calendar-list',
	calendarDayFormatter: (dateString) => {
		let result = '';
		/**
		 * @param dateString - parseable date
		 * @retunr string - <li class="calendar-item event active">
		 *     <a href="#">
		 *         <span class="weekday">st</span>
		 *         <span class="day">3</span>
		 *         <span class="month">7</span>
		 *     </a>
		 * </li>
		 */
		const d = new Date(dateString);
		const days = [ 'ne', 'po', 'út', 'st', 'čt', 'pá', 'so' ];
		result += '<li class="calendar-item"><a href="javascript:">';
		result += `<time datetime="${d.toISOString().substr(0, 10)}">`;
		result += `<span class="weekday">${days[ d.getDay() ]}</span>`;
		result += `<span class="day">${d.getDate()}</span>`;
		result += `<span class="month">${(d.getMonth() + 1)}</span>`;
		result += '</time></a></li>';
		return result;
	},
};

// The actual plugin constructor
function ZusnaCalendar(element, options) {
	this.element = element;

	this.options = $.extend(true, {}, DEFAULTS, options);

	this.defaults = DEFAULTS;
	this.name = PLUGIN_NAME;

	this.events = [];
	this.maxDays = 0;
	this.rotationStep = 0;

	this.initialise();
}

/**
 * init
 */
ZusnaCalendar.prototype.initialise = function initialise() {
	// do stuff only if some event is available
	if (this.checkEvents()) {
		this.getAllEvents();        // store all available event *from today*, or render no-events-available label

		this.renderEventPicker();   // render scrollable event picker
		this.renderEvents();        // render events into event picker

		this.enableScroller();      // store data necessary for scrolling
		this.bindScrollerHandlers();// bind scrolling functions
	}
};

/**
 * get all available calendar events
 */
ZusnaCalendar.prototype.checkEvents = function checkEvents() {
	return $(this.element).find('.event').length;
};

/**
 * get all available calendar events
 */
ZusnaCalendar.prototype.getAllEvents = function getAllEvents() {
	const self = this;
	const { events } = self;
	const today = new Date();
	$(self.element).find('.event').each((index, item) => {
		const $t = $(item);
		const eventData = {};
		eventData.date = $t.find('time').attr('datetime');
		eventData.description = `<h3>${$t.find('.event-name span').text()}</h3>`;
		eventData.description += $t.find('.description').html();
		// set event date to midnight (24:00 ~> 0:00 next day) and compare it with actual date
		// setting time to midnight is necessary for showing events of today
		if (today <= (new Date(eventData.date)).setHours(24)) {
			events.push(eventData);
		}
	});
	events.reverse();
};

/**
 * read data and build (empty) event list
 */
ZusnaCalendar.prototype.renderEventPicker = function renderEventPicker() {
	const self = this;
	let htmlResult = '';
	htmlResult += '<div class="calendar-wrapper">';
	htmlResult += '<div class="col-xs-12">';
	htmlResult += '<div class="scroller"><a href="javascript:" id="scroll-left" class="border disabled">';
	htmlResult += '<span class="hidden">předchozí</span><span class="glyphicon glyphicon-arrow-left inline-box"></span>';
	htmlResult += '</a></div>';
	htmlResult += '<div class="event-wrapper">';
	htmlResult += '<div class="in">';
	htmlResult += '<ul id="calendar" class="event-picker">';
	const today = new Date();
	// show events from July 1st till August 31st *next school year*
	const lastDate = (today.getMonth() >= 6) ?
			new Date(parseInt(today.getFullYear() + 1), 7, 31, 23, 59, 59, 999) :
			new Date(parseInt(today.getFullYear()), 7, 31, 23, 59, 59, 999);
	self.maxDays = Math.ceil((lastDate - today) / (1000 * 60 * 60 * 24));
// eslint-disable-next-line no-plusplus
	for (let i = 0; i < self.maxDays; i++) {
		htmlResult += self.options.calendarDayFormatter(today.getTime() + (i * 24 * 60 * 60 * 1000));
	}
	htmlResult += '</ul>';
	htmlResult += '</div>'; // div.in
	htmlResult += '</div>'; // div.event-wrapper
	htmlResult += '<div class="scroller"><a href="javascript:" id="scroll-right" class="border pull-right">';
	htmlResult += '<span class="hidden">následující</span><span class="glyphicon glyphicon-arrow-right inline-box"></span>';
	htmlResult += '</a></div>';
	htmlResult += '</div>'; // div.col-xs-12
	htmlResult += '<div class="col-xs-12"><div id="event" class="row event-detail"></div></div>';
	htmlResult += '</div>';
	$(self.element).find(self.options.sourceList).hide(0);
	$(self.element).append(htmlResult);
	// needs to be block to store width for future use
	$('.calendar-wrapper', self.element).show(0);

	if (!self.events.length && $(self.element).find('.event').length) {
		const noEvents = '<p class="no-events col-xs-12">Akce tohoto roku si můžete prohlédnout na stránce <a href="/cs/o-nas/kalendar">Kalendář</a>.</p>';
		$('#event', self.element).html($(noEvents));
	}
};

/**
 * push events into eventsPicker
 */
ZusnaCalendar.prototype.renderEvents = function renderEvents() {
	const self = this;
	self.events.forEach((evn) => {
		const event = evn;
		const desc = event.description;
		const evnDate = event.date;
		const $el = $('.calendar-item', '#calendar')
				.find(`time[datetime=${evnDate}]`)
				.parents('.calendar-item');
		$el.addClass('event').on(`click.${PLUGIN_NAME}`, self.renderSelectedEvent);
		const storedEvents = ($el.data(`plugin_${PLUGIN_NAME}`)) ? $el.data(`plugin_${PLUGIN_NAME}`).eventData || {} : {};
		// get other events, if any
		const todayEvents = storedEvents.description || [];
		// and merge evn w/ them
		todayEvents.push(desc);
		$el.data(`plugin_${PLUGIN_NAME}`, { eventData: { date: event.date, description: todayEvents } });
	});
	// click to show first event
	$('.calendar-item.event:first', self.element).click();
};

/**
 * calculates .event-picker width based on number of rendered events
 */
ZusnaCalendar.prototype.enableScroller = function enableScroller() {
	const self = this;
	const w = self.maxDays * $('#calendar .calendar-item:first', self.element).outerWidth(true); // width of full calendar
	$('#calendar', self.element)
			.width(w)
			.data(`plugin_${PLUGIN_NAME}`, { marginMax: w - parseInt($('#calendar').parents('.in').width()) });
};

/**
 * attach event handlers to scroller arrows
 */
ZusnaCalendar.prototype.bindScrollerHandlers = function bindScrollerHandlers() {
	// get wrapper width, e.a. scroller steps in px
	const $eventPicker = $('#calendar', this.element);
	const self = this;
	const singleEventWidth = $('.calendar-item:first', $eventPicker).outerWidth(true);
	let currentMargin = 0;

	$('#scroll-right').on(`click.${PLUGIN_NAME}`, (event) => {
		const $scroller = $(event.target); // $('#scroll-right')
		if (!$scroller.hasClass('disabled')) {
			// recalculates this.rotationStep
			self.recalculateRotationStep();
			// rotate last .event to first position
			const step = (self.rotationStep - singleEventWidth - (self.rotationStep % singleEventWidth));
			const maxMargin = $eventPicker.data(`plugin_${PLUGIN_NAME}`).marginMax - (step + 1); // +1px
			// border-right
			currentMargin = parseInt($eventPicker.css('margin-left'));
			$eventPicker
					.stop(true, true)
					.animate(
							{
								'margin-left': (currentMargin - step > -1 * maxMargin) ?
										               currentMargin - step :
										               -1 * maxMargin,
							},
							1000,
							() => {
								$('.scroller .border').removeClass('disabled');
								if (parseInt($eventPicker.css('margin-left')) <= -1 * maxMargin) {
									$scroller.addClass('disabled');
								}
							},
					);
		}
	});
	$('#scroll-left').on(`click.${PLUGIN_NAME}`, (event) => {
		const $scroller = $(event.target); // $('#scroll-left')
		if (!$scroller.hasClass('disabled')) {
			self.recalculateRotationStep(); // recalculates this.rotationStep
			// rotate last .event to first position
			const step = (self.rotationStep - singleEventWidth - (self.rotationStep % singleEventWidth));
			const minMargin = 0;
			currentMargin = parseInt($eventPicker.css('margin-left'));
			$eventPicker
					.stop(true, true)
					.animate(
							{
								'margin-left': (currentMargin + step < minMargin) ?
										               currentMargin + step :
										               minMargin,
							},
							1000,
							() => {
								$('.scroller .border').removeClass('disabled');
								if (parseInt($eventPicker.css('margin-left')) >= minMargin) {
									$scroller.addClass('disabled');
								}
							},
					);
		}
	});
};

/**
 * render event(s) for selected day
 */
ZusnaCalendar.prototype.renderSelectedEvent = function renderSelectedEvent() {
	const self = this;
	$(self).siblings().removeClass('active');
	$(self).addClass('active');

	// date YYYY-MM-DD
	const d = $(self).data(`plugin_${PLUGIN_NAME}`).eventData.date;
	// parse date YYYY-MM-DD > D/M
	const displayDate = `${parseInt(d.split('-')[ 2 ])} / ${parseInt(d.split('-')[ 1 ])}`;

	const storedEvents = $(this).data(`plugin_${PLUGIN_NAME}`).eventData;
	let htmlResult = '';
	if (storedEvents.description) {
		htmlResult += `<div class="col-sm-3 date text-center"><span>${displayDate}</span></div>`;
		htmlResult += '<div class="col-sm-9"><div class="row">';
		htmlResult += storedEvents.description.reduce((acc, item) => `${acc}<div class="col-sm-6 item">${item}</div>`, '');
		htmlResult += '</div></div>';
	}

	$('#event').html(htmlResult);
};

ZusnaCalendar.prototype.recalculateRotationStep = function recalculateRotationStep() {
	const $tpm = $('#calendarContainer').clone();
	$tpm.addClass('in'); // not .collapsed
	// .container ~ bootstrap ;; .calendar ~> head class
	$('body').append($('<div class="container calendar" id="deleteMe" />').append($tpm));
	// margin + border + padding + width
	const retVal = parseInt($('#deleteMe').find('.event-wrapper .in').outerWidth(true));
	$('#deleteMe').remove();
	this.rotationStep = retVal;
};

/**
 * decide, which methods will be "public"
 */
const API = { resize: ZusnaCalendar.prototype.recalculateRotationStep };

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *        if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *        if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[ PLUGIN_NAME ] = function plugin(value) {
	const args = arguments;

	return this.each((index, element) => {
		const $this = $(element);

		// get plugin instance
		let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

		// if there's not, create one
		if (!plugin) {
			plugin = new ZusnaCalendar(this, value);
			$this.data(`plugin_${PLUGIN_NAME}`, plugin);
		} else if (API[ value ]) {
			// if there is and first parameter is in predefined API methods, call it with rest of params
			API[ value ].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.zusnaCalendar.js